import { AxiosError } from "axios";

function isAxiosError<T = any>(err: unknown): err is AxiosError<T> {
    return err && typeof err === 'object' && (err as any).isAxiosError
}

export default isAxiosError;